import Marketplace, { SETTINGS_TRUE_VALUE } from '@spike/marketplace-model';
import { FeedingSlotMoment } from './feedingSlotTimes';

const FEEDING_MOMENT_IDS: Record<FeedingSlotMoment, number> = {
    morning: 1,
    afternoon: 2,
    evening: 3
};

export const isFeedingMomentEnabled = (marketplace: Marketplace, moment: FeedingSlotMoment): boolean =>
    marketplace.settings.find(s => s.key === `${moment}_feeding_enabled`)?.value === SETTINGS_TRUE_VALUE;

export const getMarketplaceDisabledFeedingMoments = (marketplace: Marketplace): number[] =>
    (['morning', 'afternoon', 'evening'] as const).reduce<number[]>((disabled, moment) => {
        if (!isFeedingMomentEnabled(marketplace, moment)) {
            disabled.push(FEEDING_MOMENT_IDS[moment]);
        }

        return disabled;
    }, []);
